import React, { useState, useEffect, useRef } from 'react'
import { Button, Col, Tooltip } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import moment from 'moment'
import AntdTable from '@/components/table/AntdTable'
import { formatMessageNew, paginationInit, downLoadFileBlob, saveAsJson } from '@/utils/common'
import { getAllStoreCode } from '@/services/rfid/rfidConfig/rfidStore'
import {
  getApiDetailInfoPageRfid,
  getApiDetailInfoExportRfid,
  getListAllApiTypeRfid
} from '@/services/rfid/rfidDashboard/rfidDashboard'
import SearchBar from '@/components/searchbar/SearchBar'

const dateFormat = 'YYYY-MM-DD'
const startMonth = dayjs().subtract(6, 'day')
const endMonth = dayjs()

const RFIDTunnelModalTable = props => {
  let languageState = useSelector(state => state.commonStore.language)
  let apiLs = props.selectItem && props.selectItem.apiType
  apiLs = apiLs ? [apiLs] : []
  let searchListInit = [
    {
      type: 'select',
      label: 'languageObj.rfidDashboard.api',
      key: 'apiLists',
      initialValues: apiLs,
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.rfidDashboard.store',
      key: 'storeCodes',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.rfidDashboard.messageId',
      key: 'messageId',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'timeRange',
      label: 'languageObj.rfidDashboard.timeDate',
      key: 'timeDate',
      format: dateFormat,
      disabledDate: current => {
        let falg = (current && current < moment().subtract(7, 'day')) || (current && current > moment().endOf('day'))
        return falg
      },
      initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]
  const tableColumns = [
    {
      title: formatMessageNew('languageObj.rfidDashboard.api'),
      dataIndex: 'api',
      width: 80,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidDashboard.apiStatus'),
      dataIndex: 'status',
      width: 50,
      render: text => {
        if (text) {
          return 'Fail'
        } else {
          return 'Success'
        }
      }
    },
    {
      title: formatMessageNew('languageObj.rfidDashboard.plant'),
      dataIndex: 'plant',
      width: 50,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidDashboard.errorCode'),
      dataIndex: 'errorCode',
      width: 50,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidDashboard.errorMessage'),
      dataIndex: 'errorMessage',
      width: 80,
      ellipsis: {
        showTitle: false
      },
      render: text => {
        return (
          <Tooltip
            overlayClassName="overlayClass"
            placement="topLeft"
            title={<div className="word_break_all">{text}</div>}
          >
            {text}
          </Tooltip>
        )
      }
    },
    {
      title: formatMessageNew('languageObj.rfidDashboard.messageId'),
      dataIndex: 'messageId',
      width: 80,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidDashboard.StoreOrTunnel'),
      dataIndex: 'store',
      width: 50,
      render: (text, record) => {
        return <div className="word_break_all">{text || record.sender}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidDashboard.payload'),
      dataIndex: 'payload',
      width: 50,
      render: text => {
        return text ? (
          <div onClick={() => downLoadPayLoad(text)} className="link_name_dashboard">
            {formatMessageNew('languageObj.commonLocale.download')}
          </div>
        ) : null
      }
    },
    {
      title: formatMessageNew('languageObj.rfidDashboard.time'),
      dataIndex: 'updateTime',
      width: 80
    }
  ]

  const [pagination, setPagination] = useState(paginationInit)
  const [tableList, setTableList] = useState([])
  const [searchList, setSearchList] = useState(searchListInit)
  const [queryFlag, setQueryFlag] = useState(false)
  let formRef = useRef(null)

  useEffect(() => {
    searchSelectDropFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getTableList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  const searchDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    formRef && formRef.current.clearForm()
    formRef &&
      formRef.current.setValue({
        apiLists: [],
        storeCodes: [],
        timeDate: []
      })
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchSelectDropFun = () => {
    const params = {}
    Promise.all([getListAllApiTypeRfid({}), getAllStoreCode(params)]).then(res => {
      if (res && res.length > 0) {
        searchListInit.forEach(itemFirst => {
          const arr = []
          if (itemFirst.key === 'apiLists') {
            const dt = res[0].resultData || []
            for (let index = 0; index < dt.length; index++) {
              const element = dt[index]
              arr.push({
                label: element,
                value: element
              })
            }
            itemFirst.selectList = arr
          }
          if (itemFirst.key === 'storeCodes') {
            const records = res[1].resultData || []
            for (let index = 0; index < records.length; index++) {
              const element = records[index]
              arr.push({
                label: element,
                value: element
              })
            }
            itemFirst.selectList = arr
          }
        })
        setSearchList([...searchListInit])
      }
    })
  }

  const getTableList = () => {
    let info = {}
    info = (formRef.current && formRef.current.getValue()) || {}
    let timeDate = info.timeDate
    let startTime = timeDate && timeDate[0] ? timeDate[0].format(dateFormat) : startMonth.format(dateFormat)
    let endTime = timeDate && timeDate[1] ? timeDate[1].format(dateFormat) : endMonth.format(dateFormat)
    delete info.timeDate
    let params = {
      asc: true,
      // orderByColumn: '',
      current: pagination.currentPage,
      size: pagination.pageSize,
      param: {
        ...info,
        startTime: startTime,
        endTime: endTime
      }
    }
    getApiDetailInfoPageRfid(params).then(res => {
      if (res.resultData) {
        setTableList(res.resultData.records || [])
        const pg = {
          ...pagination,
          total: res.resultData.total
        }
        setPagination(pg)
      }
    })
  }

  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }

  const downLoadFun = () => {
    let info = {}
    info = (formRef.current && formRef.current.getValue()) || {}
    let timeDate = info.timeDate
    let startTime = timeDate && timeDate[0] ? timeDate[0].format(dateFormat) : startMonth.format(dateFormat)
    let endTime = timeDate && timeDate[1] ? timeDate[1].format(dateFormat) : endMonth.format(dateFormat)
    delete info.timeDate
    const params = {
      isChinese: languageState === 'zh_CN' ? true : false,
      startTime: startTime,
      endTime: endTime,
      ...info
    }

    getApiDetailInfoExportRfid(params).then(res => {
      downLoadFileBlob(res)
    })
  }
  const downLoadPayLoad = payload => {
    saveAsJson(payload, `RFID_API_Payload_${dayjs().format('YYYYMMDD_HH_mm_ss')}.txt`)
  }

  return (
    <div>
      <div className="search-bar">
        <SearchBar ref={formRef} searchList={searchList}>
          <Col
            xs={24}
            sm={12}
            md={12}
            lg={8}
            xl={8}
            xxl={8}
            className="right_search"
            style={{ justifyContent: 'flex-end' }}
          >
            <Button icon={<SearchOutlined />} type="primary" onClick={searchDataBtn}>
              {formatMessageNew('languageObj.commonLocale.search')}
            </Button>
            <Button onClick={searchClearDataBtn}>{formatMessageNew('languageObj.commonLocale.clear')}</Button>
            <Button type="primary" onClick={downLoadFun}>
              {formatMessageNew('languageObj.commonLocale.download')}
            </Button>
          </Col>
        </SearchBar>
      </div>
      <div className="content-container mt15">
        <AntdTable dataSource={tableList} columns={tableColumns} pagination={pagination} onChange={handleTableChange} />
      </div>
    </div>
  )
}
export default RFIDTunnelModalTable
